import { getAssetsImage } from "@Components/Modules/Helpers";
import type { PropsWithStyleX } from "@stylex/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export default (props: PropsWithStyleX) => (
    <img
        {...stylex.props(props.styleX)}
        src={getAssetsImage(process.env.ClockSmall)}
        alt="clock icon"
        aria-hidden
    />
);
